// Generated automatically by the "build:css-postfix" script
export const cssPostfix = 'af0670f1';
//# sourceMappingURL=cssPostfix.js.map